var d3 = {
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-shape/dist/d3-shape.min"),
};

var pym = require("./lib/pym");

var pymChild;

var onWindowLoaded = function() {
  // you would format data here if you needed to
  // var data = formatData(window.DATA);
  renderCityKey();

  window.addEventListener("resize", () => render());

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};



var { isMobile } = require("./lib/breakpoints");

module.exports = function(config) {
  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");





  var lookup = {};
  Object.keys(config.data[0]).forEach(function(key) {
    lookup[key] = config.data[0][key];
  });

  // Dimensions
  var width = config.width || 640;
  var height = config.width || 640; // square
  var cx = width / 2;
  var cy = height / 2;

  // Ring config
  var outerR       = (isMobile ? width * 0.37 : width * 0.38);
  var markerOuterR = (isMobile ? width * 0.42 : width * 0.42);
  var innerR       = (isMobile ? width * 0.28 : width * 0.26);
  var segments     = 24;
  var gapDeg       = 1.5;
  var segDeg       = (360 / segments) - gapDeg;
  var rotateOffset = -7.5; // degrees counter-clockwise
  var baseOffset   = -90 + rotateOffset;
  var markerHours  = new Set([0, 6, 12, 18]);
  var labels       = [
    { hour: 0,  text: "12 a.m." },
    { hour: 6,  text: "6 a.m."  },
    { hour: 12, text: "12 p.m." },
    { hour: 18, text: "6 p.m."  },
  ];

  var toRad = function(d) { return d * Math.PI / 180; };

  function polarToXY(angle, r) {
    return [
      cx + r * Math.cos(toRad(angle)),
      cy + r * Math.sin(toRad(angle)),
    ];
  }

function segmentPath(startAngle, endAngle, inner, outer) {
  var sweep = ((endAngle - startAngle) + 360) % 360;
  var largeArc = sweep > 180 ? 1 : 0;

  var p1 = polarToXY(startAngle, outer);
  var p2 = polarToXY(endAngle, outer);
  var p3 = polarToXY(endAngle, inner);
  var p4 = polarToXY(startAngle, inner);
  return [
    "M", p1[0], p1[1],
    "A", outer, outer, 0, largeArc, 1, p2[0], p2[1],  // outer arc clockwise
    "L", p3[0], p3[1],
    "A", inner, inner, 0, largeArc, 0, p4[0], p4[1],  // inner arc counter-clockwise
    "Z",
  ].join(" ");
}

  // Create wrapper + SVG
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .attr("viewBox", "0 0 " + width + " " + height);


  // highlight risk range

  function toDecimalHour(timeStr) {
    var parts = timeStr.split(":");
    var hours   = parseInt(parts[0], 10);
    var minutes = parseInt(parts[1], 10);
    return hours + minutes / 60;
  }

  var highlightStart = toDecimalHour(config.data[0].matchEarly);  // 2:30
  var highlightEnd   = toDecimalHour(config.data[0].matchEnd);  // 4:30

  var highlightStartAngle = baseOffset + (highlightStart / 24) * 360;
  var highlightEndAngle   = baseOffset + (highlightEnd   / 24) * 360;

  chartElement
    .append("path")
    .attr("d", segmentPath(highlightStartAngle, highlightEndAngle, innerR - 4, markerOuterR + 4))
    .attr("fill", "#E8E8E8")
    .attr("stroke", "#000")
    .attr("stroke-width", 0)
    .attr("stroke-dasharray", "6,6")
    .attr("rx", 4);


  // Draw segments
  var segData = d3.range(segments).map(function(i) {
    var isMarker   = markerHours.has(i);
    var startAngle = baseOffset + i * (360 / segments) + gapDeg / 2;
    var endAngle   = startAngle + segDeg;
    var outer      = isMarker ? markerOuterR : outerR;
    var value      = lookup[i] || 0; // attach value to each segment
    return { startAngle, endAngle, inner: innerR, outer, isMarker, value };
  });

  chartElement
    .selectAll("path.segment")
    .data(segData)
    .enter()
    .append("path")
    .attr("class", function(d) { return "segment" + (d.isMarker ? " marker" : ""); })
    .attr("d", function(d) {
      return segmentPath(d.startAngle, d.endAngle, d.inner, d.outer);
    })
    .attr("fill", function(d) {
      return config.colorFn(d.value);
    });

  // chartElement
  // .append("text")
  // .attr("x", cx)
  // .attr("y", cy)
  // .attr("text-anchor", "middle")
  // .attr("dominant-baseline", "central")
  // .attr("font-size", isMobile ? 14 : 18)
  // .attr("fill", config.labelColor || "#111")
  // .text(config.data[0].City);

  function splitOnSlash(text) {
  const idx = text.indexOf("/");

  if (idx === -1) {
    return [text];
  }

  return [
    text.slice(0, idx + 1), // includes "/"
    text.slice(idx + 1)
  ];
}


const city = config.data[0].City;

const lines = city.includes("/")
  ? [
      city.slice(0, city.indexOf("/") + 1),
      city.slice(city.indexOf("/") + 1)
    ]
  : [city];

  const text = chartElement
  .append("text")
  .attr("x", cx)
  .attr("y", cy + 6)
  .attr("text-anchor", "middle")
  .attr("font-size", isMobile ? 14 : 18)
  .attr("fill", config.labelColor || "#111");

lines.forEach((line, i) => {
  text.append("tspan")
    .attr("x", cx)
    .attr(
      "dy",
      i === 0
        ? `${-(lines.length - 1) * 0.6}em`
        : "1.2em"
    )
    .text(line);
});






  // Draw labels
  chartElement
    .selectAll("text.ring-label")
    .data(labels)
    .enter()
    .append("text")
    .attr("class", "ring-label")
    .attr("x", function(d) {
      var startAngle = baseOffset + d.hour * (360 / segments) + gapDeg / 2;
      var midAngle   = startAngle + segDeg / 2;
      return polarToXY(midAngle, markerOuterR + 24)[0];
    })
    .attr("y", function(d) {
      var startAngle = baseOffset + d.hour * (360 / segments) + gapDeg / 2;
      var midAngle   = startAngle + segDeg / 2;
      return polarToXY(midAngle, markerOuterR + 24)[1];
    })
    .attr("text-anchor", "middle")
    .attr("dominant-baseline", "central")
    .attr("font-size", isMobile ? 13 : 16)
    .attr("fill", config.labelColor || "#111")
    .text(function(d) { return d.text; });


  chartElement
    .append("path")
    .attr("d", segmentPath(128, 131, innerR - 16, markerOuterR + 8))
    .attr("fill", "#000")
    .attr("stroke", "#000")
    .attr("stroke-width", 0)
    .attr("stroke-dasharray", "6,6")
    .attr("rx", 4);

      chartElement
  .append("text")
  .attr("x", -10)
  .attr("y", 220)
  .attr("text-anchor", "left")
  .attr("dominant-baseline", "central")
  .attr("font-size", isMobile ? 12 : 14)
  .attr("fill", config.labelColor || "#111")
  .text("Final match");



    
};

